<template>
  <v-card max-width="400" style="border-radius: 0px;" class="transaction-details">
    <v-card-title class="header">
      <div style="display: flex; flex-direction: column;">
        <span class="font-weight-black title white--text">{{recordOperation()}}</span>
        <div style="display: flex; align-items: baseline;">
          <span style="color: #BCC1D1; font-size: 14px;">{{recordDate()}}</span>
          <span style="color: #BCC1D1; font-size: 12px; margin-left: 8px">{{recordTime()}}</span>
        </div>
      </div>
      <div class="ml-4">
        <v-tooltip top :color="textColorForChip(record)">
          <template v-slot:activator="{ on }">
            <v-chip class="fixed-chip" :color="statusColorFor(record)" :text-color="textColorForChip(record)" v-on="on">{{ statusTextFor(record) }}</v-chip>
          </template>
          <span class="font-weight-bold">{{ statusHelpFor(record) }}</span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <v-icon style="cursor: pointer" right dark @click="$emit('closeDialog')">close</v-icon>
    </v-card-title>
    <v-card-text style="color: #44517B;">
      <v-container grid-list-md pt-0 pb-0>
        <v-layout wrap>
          <v-flex xs12>
            <div>
              <v-chip
                color="rgba(39, 218, 188, 0.2)"
                text-color="#27DABC"
                class="chip-title"
              >
                {{i18n('DETALHES')}}
              </v-chip>
            </div>
            <div>
              <span class="font-size-10">{{i18n('DATA')}}:</span><span class="font-size-14"> {{recordDate()}} </span><span style="font-size: 12px;">{{recordTime()}}</span>
            </div>
            <div><span class="font-size-10">{{i18n('TRANSAÇÃO')}}:</span><span class="nowrap font-size-10"> {{recordId()}} </span></div>
            <div><span class="font-size-10">{{i18n('TRANSFERÊNCIA')}}:</span><span class="nowrap font-size-10"> {{wireId()}} </span></div>
            <div class="mb-3">
              <span class="font-size-10">{{i18n('CÂMBIO')}}:</span><span class="font-size-14"> {{exchangeRate()}}</span>
            </div>
            <div>
              <v-chip
                color="rgba(39, 218, 188, 0.2)"
                text-color="#27DABC"
                class="chip-title"
              >
                {{i18n('ORIGEM')}}
              </v-chip>
            </div>
            <div class="font-size-14">{{senderName()}}</div>
            <div class="font-size-10">
              {{senderDocumentType()}} {{senderDocumentNumber()}}
            </div>
            <div><span class="font-size-10">{{fromBankAccount()}}</span></div>
            <div class="mb-3"><span class="font-size-10">{{i18n('VALOR')}}:</span><span class="font-size-14"> {{originValue()}} </span><span class="font-size-10">({{originCurrency()}})</span>
              <v-chip small v-if="this.record.from_credit_card"><v-icon>credit_card</v-icon>Cartão de crédito</v-chip>
              <v-chip small v-if="this.isPendingReverseExchange"><v-icon>hourglass_bottom</v-icon>Valor aproximado</v-chip>
            </div>
            
            <div>
              <v-chip
                color="rgba(39, 218, 188, 0.2)"
                text-color="#27DABC"
                class="chip-title"
              >
                {{i18n('DESTINO')}}
              </v-chip>
            </div>
            <div class="font-size-14">{{receiverName()}}</div>
            <div class="font-size-10">
              {{receiverDocumentType()}} {{receiverDocumentNumber()}}
            </div>
            <div><span class="font-size-10">{{toBankAccount()}}</span></div>
            <div class="mb-2"><span class="font-size-10">{{i18n('VALOR')}}:</span><span class="font-size-14"> {{targetValue()}} </span><span class="font-size-10">({{targetCurrency()}})</span>
              <v-chip small v-if="this.record.estimated_value_until_exchange"><v-icon>compare_arrows</v-icon>{{i18n('Exchange reverso')}}</v-chip>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn flat style="color: #44517B; flex: 1" @click="$emit('closeDialog')">{{i18n('Fechar')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import utils from "./shared/Utils"
export default {
  name: 'CustomerScheduledBankTransactionDetailsCard',
  props: {
    record: {
      type: Object
    }
  },
  data: (vm) => {
    return {
      exchange_rate: 1.0,
      company: false
    }
  },
  computed: {
    toBankAccountOwner() {
      return this.record.to_bank_account && this.record.to_bank_account.owner_company || {}
    },
    subjectId() {
      return this.record.subject && this.record.subject.id
    },
    companyId() {
      return this.company && this.company.id
    },
    senderCompany() {
      if (this.subjectId === this.companyId) {
        return this.company
      }

      return this.record.subject_is_receiver ? this.company : this.record.subject
    },
    receiverCompany() {
      if (this.subjectId === this.companyId) {
        return this.company
      }

      return this.record.subject_is_receiver ? this.record.subject : this.company
    },
    isPendingReverseExchange() {
      return this.record.estimated_value_until_exchange && this.record.status == 'pending'
    },
    exchangeCurrencies() {
      return `${this.record.currency}${this.record.exchange_currency}`.toLowerCase()
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    recordId() {
      return String(this.record.id).toUpperCase()
    },
    recordOperation() {
      return `${ this.record.currency }/${ this.record.exchange_currency }`
    },
    senderDocumentType() {
      if (!this.senderCompany) { return 'N/A' }
      return this.senderCompany.document_type.toUpperCase()
    },
    senderDocumentNumber() {
      if (!this.senderCompany) { return 'N/A' }
      return utils.mask(this.senderCompany.document_type, this.senderCompany.document_number)
    },
    senderName() {
      if (!this.senderCompany) { return 'N/A' }
      return this.senderCompany.social_name
    },
    receiverDocumentType() {
      if (!this.receiverCompany) { return 'N/A' }
      return this.receiverCompany.document_type.toUpperCase()
    },
    receiverDocumentNumber() {
      if (!this.receiverCompany) { return 'N/A' }
      return utils.mask(this.receiverCompany.document_type, this.receiverCompany.document_number)
    },
    receiverName() {
      if (!this.receiverCompany) { return 'N/A' }
      return this.receiverCompany.social_name
    },
    recordDate() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[0]
    },
    recordTime() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[1]
    },
    originCurrency() {
      return this.record.currency
    },
    targetCurrency() {
      return this.record.exchange_currency
    },
    originValue() {
      if (this.isPendingReverseExchange) {
        this.getExchangeRateForTransaction()
        return (parseFloat(this.targetValue()) / parseFloat(this.exchange_rate)).toFixed(2)
      } else {
        return this.record.value
      }
    },
    targetValue() {
      const approved = this.record.bank_transaction && this.record.bank_transaction.exchange_approved
      const reverse = this.record.estimated_value_until_exchange
      if (!approved && !reverse) { return 'N/A' }
      return (this.record.bank_transaction && this.record.bank_transaction.exchanged_value)
      || (this.record.estimated_value_until_exchange && this.record.exchanged_value)
      || 'N/A'
    },
    exchangeRate() {
      const approved = this.record.bank_transaction && this.record.bank_transaction.exchange_approved
      if (!approved) { return 'N/A' }
      return (this.record.bank_transaction && this.record.bank_transaction.exchange_rate) || 'N/A'
    },
    getExchangeRateForTransaction() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.exchange_rate = response.body.data[this.exchangeCurrencies]
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.exchange_rates, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    fromBankAccount() {
      return utils.longAccountName(this.record.from_bank_account, this.i18n)
    },
    toBankAccount() {
      return utils.longAccountName(this.record.to_bank_account, this.i18n)
    },
    wireId() {
      return String(this.record.bank_transaction && this.record.bank_transaction.wire_id || 'N/A').toUpperCase()
    },
    statusTextFor(record) {
      const status_map = {
        canceled: this.i18n('Transação Cancelada'),
        pending: this.i18n('Transação Pendente'),
        identified: this.i18n('Transação Identificada'),
        exchanged: this.i18n('Transação Convertida'),
        wired: this.i18n('Transação Transferida')
      }
      return status_map[record.status]
    },
    statusHelpFor(record) {
      const status_help_map = {
        canceled: this.i18n('Transação cancelada'),
        pending: this.i18n('Aguardando pela identificação do transferência de entrada'),
        identified: this.i18n('Transferência de entrada identificada'),
        exchanged: this.i18n('Taxa de câmbio fechada'),
        wired: this.i18n('O valor convertido foi enviado')
      }
      return status_help_map[record.status]
    },
    statusColorFor(record) {
      const status_color_map = {
        canceled: 'rgba(200, 200, 200, 0.8)',
        pending: 'rgba(144, 140, 99, 0.3)',
        identified: 'rgba(103, 145, 220, 0.3)',
        exchanged: 'rgba(68, 188, 202, 0.4)',
        wired: 'rgba(7, 169, 124, 0.3)'
      }
      return status_color_map[record.status]
    },
    textColorForChip(record) {
      const status_chip_color_map = {
        canceled: '#4e4e4e',
        pending: '#908c63',
        identified: '#a4b6d6',
        exchanged: '#40c1d0de',
        wired: '#07a97c'
      }
      return status_chip_color_map[record.status]
    }
  },
  mounted() {
    this.$root.store.getCompany((company)=>{
      if (company) {
        this.company = company
      }
    }, (error)=>{
    })
  }
}
</script>
<style>
.transaction-details .header {
  background-color: #0C2E4A !important;
  border-radius: 0px !important;
}

.transaction-details .font-size-10 {
  font-size: 10px;
}
.transaction-details .font-size-14 {
  font-size: 14px;
}

.transaction-details .chip-title {
  margin: 0;
  font-size: 10px;
  border-radius: 0px;
  height: 14px;
}
.transaction-details .chip-title .v-chip__content {
  padding-left: 7px;
  padding-right: 7px;
}
</style>



// WEBPACK FOOTER //
// src/CustomerInternalTransactionDetailsCard.vue